import React from "react";
import { List, ListItem } from "@chakra-ui/core";
import { ICartItemDetail } from "@engyalo/storefront-types";

export const CustomCartItem = ({ cart, product }: ICartItemDetail) => {
  const cartItem = cart[product?.cartId ?? ""];

  if (!cartItem) {
    return null;
  }

  return (
    <List mb="4" styleType="square">
      {cartItem.customizations?.map((option) => (
        <ListItem key={option?.id} color="gray.100" fontSize="xs">
          {option?.name}:{" "}
          {option?.customizations?.map((item) => item?.name)?.join(", ")}
        </ListItem>
      ))}
    </List>
  );
};
